import ko from 'knockout';
import $ from 'jquery';

// NOTE: Do not use jquery plugin to apply mask.
// 'inputmask' and old 'jquery.inputmask' use the same extender name.
import {default as Inputmask} from 'rgs-inputmask';

ko.bindingHandlers.inputmask = {
	after: [ 'value' ],

	init: function (element, valueAccessor) {
		const mask = ko.unwrap(valueAccessor());
		const observable = mask.value;

		if (ko.isObservable(observable)) {

			$(element).on('focusout change', function () {

				if ($(element).inputmask('isComplete')) {
					observable($(element).val());
				} else {
					observable(null);
				}

			});
		}

		element.onmouseleave = (e) => {
			e.stopImmediatePropagation();
		};

		Inputmask(mask).mask(element);
	},

	update: function (element, valueAccessor) {
		const mask = ko.unwrap(valueAccessor());
		const observable = mask.value;

		if (ko.isObservable(observable)) {
			const valueToWrite = observable();
			$(element).val(valueToWrite);
		}

		Inputmask(mask).mask(element);
	},
};
